import React, { useRef, useEffect, useState } from "react";
import "./TwoColumnMedia.css";

const TwoColumnMedia = ({ media, userInteracted }) => {
  const mediaRefs = useRef([]);

  const [muted, setMuted] = useState({});
  const [isPlaying, setIsPlaying] = useState({});
  const [showControls, setShowControls] = useState({});
  const [volume, setVolume] = useState({});
  let hasUserInteracted = userInteracted;

  useEffect(() => {
    mediaRefs.current.forEach((mediaRef, index) => {
      if (mediaRef && media[index]?.type === "video") {
        mediaRef.muted = true; // Set audio to off
        setShowControls((prev) => ({ ...prev, [index]: false }));

        // Add mouseover and mouseout event listeners
        mediaRef.addEventListener("mouseover", () => {
          setShowControls((prev) => ({ ...prev, [index]: true }));
        });

        mediaRef.addEventListener("mouseout", () => {
          setShowControls((prev) => ({ ...prev, [index]: false }));
        });

        // Add scroll event listener
        window.addEventListener("scroll", () =>
          twoColumnMediaHandleScrollMediaComponents(index)
        );
      }
    });

    // Add an event listener to set the flag when the user interacts with any media
    window.addEventListener("click", () => {
      hasUserInteracted = true;
    });

    return () => {
      // Remove scroll event listener on unmount
      mediaRefs.current.forEach((mediaRef, index) => {
        if (media[index]?.type === "video") {
          window.removeEventListener("scroll", () =>
            twoColumnMediaHandleScrollMediaComponents(index)
          );
        }
      });
    };
  }, [media]);

  const twoColumnMediaHandleScrollMediaComponents = (index) => {
    const mediaElement = mediaRefs.current[index];
    if (mediaElement) {
      if (media[index]?.type === "video") {
        const mediaElement = mediaRefs.current[index];
        const mediaRect = mediaElement.getBoundingClientRect();
        const scrollPosition = window.scrollY + window.innerHeight / 2;
        const mediaMiddle =
          window.scrollY + mediaRect.top + mediaRect.height / 2;

        if (
          scrollPosition < mediaMiddle - mediaRect.height * 0.85 ||
          scrollPosition > mediaMiddle + mediaRect.height * 0.85
        ) {
          if (mediaElement && !mediaElement.paused) {
            mediaElement.pause();
            //setMuted((prev) => ({ ...prev, [index]: true })); // Reset unmute button when media is paused
            //fadeOutAudio(index);
          }
        } else {
          if (mediaElement && mediaElement.paused) {
            if (hasUserInteracted) {
              mediaElement.play();
              //setMuted((prev) => ({ ...prev, [index]: false }));
              //fadeInAudio(index);
            }
          }
        }
      }
    }
  };

  const fadeInAudio = (index) => {
    const audio = mediaRefs.current[index];
    let volume = 0;
    setVolume((prev) => ({ ...prev, [index]: 0 }));
    const interval = setInterval(() => {
      if (volume < 1) {
        volume += 0.1;
        audio.volume = Math.min(volume, 1);
        setVolume((prev) => ({ ...prev, [index]: audio.volume }));
      } else {
        clearInterval(interval);
      }
    }, 500);
  };

  const fadeOutAudio = (index) => {
    const audio = mediaRefs.current[index];
    let volume = audio.volume;
    const interval = setInterval(() => {
      if (volume > 0) {
        volume -= 0.1;
        audio.volume = Math.max(volume, 0);
        setVolume((prev) => ({ ...prev, [index]: audio.volume }));
      } else {
        clearInterval(interval);
      }
    }, 500);
  };

  const renderMedia = (mediaItem, index) => {
    const style = {
      height: mediaItem.height || "auto",
      width: mediaItem.width || "100%",
      objectFit: mediaItem.objectFit || "contain",
      display: "block",
      margin: mediaItem.position === "center" ? "auto" : "initial",
      alignSelf: mediaItem.verticalAlign || "center",
    };

    if (mediaItem.type === "image") {
      return (
        <img
          ref={(el) => (mediaRefs.current[index] = el)}
          src={mediaItem.src}
          alt={mediaItem.alt}
          style={style}
          class="two-column-image"
        />
      );
    } else if (mediaItem.type === "video") {
      return (
        <div className="video-container" style={style}>
          <video
            className="full-width-video"
            playsInline
            webkit-playsinline="true"
            preload="metadata"
            ref={(el) => (mediaRefs.current[index] = el)}
            src={mediaItem.src}
            muted
            loop
            controls={showControls[index]}
            style={style}
            onError={(e) => console.error("Video error:", e.target.error)}
            onLoadedMetadata={() => {
              if (!isPlaying[index]) {
                mediaRefs.current[index].play();
                setIsPlaying((prev) => ({ ...prev, [index]: true }));
              }
            }}
            onError={(e) => {
              console.error("Video playback error:", e.target.error);
            }}
          />
        </div>
      );
    }
  };

  return (
    <div className="grid-container">
      {Array.isArray(media)
        ? media.map((item, index) => (
            <div
              key={index}
              className={`grid-item ${index === 0 ? "left" : "right"}`}
            >
              {renderMedia(item, index)}
            </div>
          ))
        : renderMedia(media[0], 0)}
    </div>
  );
};

export default TwoColumnMedia;
